import * as Blockly from 'blockly/core';
import { useBlockFunctionStore } from '@/stores/useBlockFunctionStore';

export const funcDefinitionCodes = new Map<string, string>();

const RETURN_TYPE_MAP: Record<string, string> = {
    float: 'float',
    String: 'String',
    bool: 'bool',
};

const DEFAULT_RETURN_MAP: Record<string, string> = {
    float: 'return 0;',
    String: 'return "";',
    bool: 'return false;',
};

export function resetFuncDefinitions(): void {
    funcDefinitionCodes.clear();
}

export function register(gen: any): void {
    gen.forBlock['func'] = function (block: Blockly.Block): string {
        const fnId: string = (block as any)._fnId ?? '';
        const fnName: string = (block as any)._fnName ?? '';
        if (!fnName) return '';

        const fn = useBlockFunctionStore.getState().functions.find((f) => f.id === fnId);
        const returnType = fn?.returnType ? RETURN_TYPE_MAP[fn.returnType] ?? 'void' : 'void';

        const paramDefs = (fn?.params ?? []).map((p, i) => {
            const paramField = block.getField(`PARAM_${p.id}`);
            const paramName = paramField?.getValue() ?? `引数${i + 1}`;
            // 未設定の引数があればスキップ
            if (/^引数\d+$/.test(paramName)) return null;
            const type = p.type === 'float' ? 'float' : p.type === 'String' ? 'String' : 'bool';
            return `${type} ${paramName}`;
        });

        if (paramDefs.some((p) => p === null)) return '';

        const params = paramDefs.join(', ');

        let body = gen.statementToCode(block, 'DO');

        if (fn?.returnType && !body.includes('return ')) {
            body += `  ${DEFAULT_RETURN_MAP[fn.returnType]}\n`;
        }

        const code = `${returnType} ${fnName}(${params}) {\n${body}}\n`;
        funcDefinitionCodes.set(fnName, code);

        return '';
    };
}
